<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-8 col-lg-3 col-xl-3">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              id="sel_farm"
              @clear="
                farm_id = null;
                renderer = false;
                hotSettings.data = [];
              "
              clearable
              @change="loadFiles"
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div
            class="col-12 col-sm-6 col-md-8 col-lg-5 col-xl-5"
            v-if="farm_id"
          >
            <label>{{ $t('common_words.file') }} *</label>
            <br />
            <el-select
              @change="loadData"
              @clear="cleanFileList()"
              clearable
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-file shadow-sm"
              size="large"
              v-model="file_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in filesList"
                class="select-primary"
                :value="option"
                :label="option"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-2" v-if="file_sel && farm_id && boxes_names == null">
            <l-button
              wide
              type="info"
              class="btn-filter shadow-sm"
              style="margin-top: 30px"
              @click="validate"
            >
              {{ $t('common_words.save') }}
            </l-button>
          </div>
          <!--<div
            class="col-2"
            v-if="farm_id == 75"
          >--><!--Demo-->
          <!--<div
            class="col-2"
            v-if="farm_id == 3"
          >--><!--Produccion-->
          <!--<l-button
              wide
              type="primary"
              class="btn-filter shadow-sm"
              style="margin-top: 30px;"
              @click="syncScalesBoxes"
            >
              Sincronizar
            </l-button>
          </div>-->
        </div>
        <br />
      </card>
      <card class="custom-shadow-card-header" v-if="renderer">
        <br />
        <div class="row">
          <div class="col-12 mb-4">
            <h5>
              <strong>1. {{ $t('common_words.file_info') }}</strong>
            </h5>
            <p>{{ $t('common_words.file_selected_info') }}.</p>
          </div>
        </div>
        <div class="selArchBasc">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-6 text-center">
              <p
                class="filetittle"
                style="background-color: #4f8949; color: white"
              >
                <strong>{{ $t('common_words.file_information') }}</strong>
              </p>
              <p class="mb-1">
                <strong>{{ $t('common_words.farm') }}:</strong>
                {{ content_file.farm }}
              </p>
              <p class="mb-1">
                <strong>{{ $t('common_words.name') }}:</strong>
                {{ content_file.name_file }}
              </p>
              <p class="mb-1">
                <strong>{{ $t('common_words.date') }}:</strong>
                {{ content_file.date_file }}
              </p>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 text-center">
              <p
                class="filetittle"
                style="background-color: #4f8949; color: white"
              >
                <strong>{{ $t('common_words.data') }}</strong>
              </p>
              <div>
                <table class="table table-bordered">
                  <tbody>
                    <tr
                      v-for="(box, amount) in content_file.count_boxes"
                      :key="box + '-' + amount"
                    >
                      <td>{{ amount }}</td>
                      <th scope="col">{{ box }}</th>
                    </tr>
                    <tr>
                      <th scope="col">{{ $t('common_words.record_total') }}</th>
                      <th scope="col">{{ content_file.total }}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="col-12 mt-4 mb-4">
          <h5>
            <strong>2. {{ $t('common_words.file_content') }}</strong>
          </h5>
          <p>{{ $t('production.scale_box_selected') }}.</p>
        </div>
        <div
          class="alert alert-success"
          role="alert"
          v-show="boxes_names == null"
        >
          {{ $t('common_words.file_success') }}
        </div>
        <div
          class="alert alert-danger"
          role="alert"
          v-show="boxes_names != null"
        >
          <br />
          <strong>{{ $t('common_words.file_error') }}</strong
          ><br />
          {{ $t('production.causes') }}
          <ol>
            <li>
              {{ $t('production.the_s') }}
              <em>{{ $t('production.boxes_s') }} {{ boxes_names }}</em>
              {{ $t('production.is_not_associated_farm') }}
              <em>{{ content_file.farm }}</em>
            </li>
          </ol>
        </div>
        <div class="row mb-4">
          <div class="col-12 text-center">
            <l-button
              wide
              type="info"
              class="btn-filter shadow-sm"
              @click="validateFile"
            >
              {{ $t('common_words.validate_file') }}
            </l-button>
          </div>
        </div>
        <div class="row">
          <div
            class="col-12 hot"
            v-if="hotSettings.data.length > 0"
            ref="handsontable"
          >
            <hot-table
              style="border-bottom: 1px solid #ccc"
              :settings="hotSettings"
              class="table-boxes"
            ></hot-table>
          </div>
          <div v-else>
            <h5>{{ $t('common_words.invalid_file') }}</h5>
          </div>
        </div>
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { HotTable } from '@handsontable/vue';
import Handsontable from 'handsontable';
import { mapActions } from 'vuex';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import mixinMasters from 'src/util/mixinMasters';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

Handsontable.renderers.registerRenderer(
  'colorRenderer',
  function (hotInstance, td, row, column, prop, value, cellProperties) {
    Handsontable.renderers.NumericRenderer.apply(this, arguments);
    if (value == '') {
      td.classList = ['alert', 'alert-danger'];
    }
  }
);

export default {
  components: {
    [HotTable.name]: HotTable,
  },
  computed: {
    colHeaders() {
      return [
        i18n.t('common_words.gross_weight'),
        i18n.t('common_words.code'),
        i18n.t('production.box'),
        i18n.t('common_words.status'),
        i18n.t('common_words.hour'),
      ];
    },
  },

  data() {
    return {
      message: null,
      content_file: [],
      filesList: [],
      farm_id: null,
      user_id: this.$store.state.auth.user.id,
      farms: [],
      file_sel: null,
      renderer: false,
      boxes_names: '',
      hotSettings: {
        rowHeaders: true,
        columns: [
          {
            data: 0,
            readOnly: true,
          },
          {
            data: 1,
          },
          {
            data: 2,
            readOnly: true,
          },
          {
            data: 3,
          },
          {
            data: 4,
            readOnly: true,
          },
        ],
        stretchH: 'all',
        data: [],
        autoRowSize: false,
        autoColumnSize: false,
        columnSorting: true,
        contextMenu: true,
        height: 600,
        afterScrollVertically: function () {
          document
            .getElementsByClassName('htCore')[0]
            .getElementsByTagName('tbody')[0]
            .getElementsByTagName('tr')
            .forEach((item) => {
              let box = item.getElementsByTagName('td')[1];
              if (
                box.innerText != 'Caja' &&
                (box.innerText == '' ||
                  !Object.values(
                    JSON.parse(sessionStorage.getItem('boxes'))
                  ).includes(box.innerText.toUpperCase()))
              ) {
                box.className = 'alert alert-danger';
              } else {
                box.className = '';
              }
            });
        },
        afterRemoveRow: function (index, amount, physicalRows, source) {
          let data = this.getData();
          physicalRows.forEach((element) => {
            data.splice(element, 1);
          });
        },
      },
    };
  },

  mixins: [MixinPermissions, MixinNotification, mixinMasters, MixinMenu],

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    cleanFileList() {
      this.message = null;
      let file = this.content_file.name_file;

      SweetAlert.delete(file).then((result) => {
        if (result.value) {
          this.showHideLoading(true);
          Axios.postMasters({
            route: 'scales/boxes/delete',
            file: 'boxes/' + file,
          })
            .then((response) => {
              this.filesList.splice(this.filesList.indexOf('boxes/' + file), 1);
              this.showHideLoading();
              this.renderer = false;
              this.hotSettings.data = [];
              this.file_sel =
                this.filesList.length > 0 ? this.filesList[0] : null;
              this.message = response.data.message;

              if (this.file_sel) {
                this.loadData();
              } else {
                this.notificationDeleteFile();
              }
            })
            .catch((error) => {
              this.showHideLoading();
              this.message = null;
              SweetAlert.warning(error.response.data.message);
            });
        } else {
          this.message = null;
          this.file_sel = 'boxes/' + this.content_file.name_file;
        }
      });
    },

    loadFiles() {
      this.file_sel = null;
      this.renderer = false;
      this.hotSettings.data = [];
      this.message = null;
      this.showHideLoading(true);

      Axios.postMasters({
        route: 'scales/boxes/listdirectory',
        farm_id: this.farm_id,
        directory: 'boxes',
      })
        .then((response) => {
          this.filesList = response.data.files;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    notificationDeleteFile() {
      if (this.message) {
        this.showNotification(
          `` + this.message + ``,
          'success',
          'nc-check-2',
          `${i18n.t('common_words.success_operation')}...`
        );
      }
    },

    loadData() {
      if (this.file_sel) {
        this.showHideLoading(true);
        Axios.postMasters({
          route: 'scales/boxes/getfilecontent',
          farm_id: this.farm_id,
          filename: this.file_sel,
        })
          .then((response) => {
            if (response.data && response.data.handsontable.length > 0) {
              this.content_file = response.data;

              switch (response.data.scale_version) {
                case 'XR3000':
                  this.hotSettings.colHeaders = [
                    'Peso Bruto',
                    'Código',
                    'Caja',
                  ];
                  this.hotSettings.columns = [
                    { data: 0, readOnly: true },
                    { data: 1 },
                    { data: 2, readOnly: true },
                  ];
                  break;
                case 'XR5000PC':
                  this.hotSettings.colHeaders = [
                    'Peso Bruto',
                    'Código',
                    'Caja',
                    'Modificado',
                    'Usuario',
                    'Notas',
                    'Fecha',
                    'Hora',
                  ];
                  this.hotSettings.columns = [
                    { data: 0, readOnly: true },
                    { data: 1 },
                    { data: 2, readOnly: true },
                    { data: 3 },
                    { data: 4, readOnly: true },
                    { data: 5 },
                    { data: 6, readOnly: true },
                    { data: 7, readOnly: true },
                  ];
                  break;
                case 'XR5000PHONE':
                  this.hotSettings.colHeaders = [
                    'Peso Bruto',
                    'Código',
                    'Caja',
                    'Fecha',
                    'Hora',
                  ];
                  this.hotSettings.columns = [
                    { data: 0, readOnly: true },
                    { data: 1 },
                    { data: 2, readOnly: true },
                    { data: 3, readOnly: true },
                    { data: 4, readOnly: true },
                  ];
                  break;
                default:
                  (this.hotSettings.colHeaders = [
                    'Peso Bruto',
                    'Código',
                    'Caja',
                    'Estado',
                    'Hora',
                  ]),
                    (this.hotSettings.columns = [
                      { data: 0, readOnly: true },
                      { data: 1 },
                      { data: 2, readOnly: true },
                      { data: 3 },
                      { data: 4, readOnly: true },
                    ]);
                  break;
              }

              this.renderer = false;
              this.hotSettings.data = this.content_file.handsontable;
              delete this.content_file.handsontable;

              this.$nextTick(function () {
                this.renderer = true;
                this.verifyBoxes(
                  response.data.count_boxes,
                  response.data.boxes
                ).then((resp) => {
                  this.drawBadRows();
                });
              });
            }

            this.showHideLoading();
            this.notificationDeleteFile();
          })
          .catch((error) => {
            this.showHideLoading();
            this.notificationDeleteFile();
            SweetAlert.warning(error.response.data.message);
          });
      }
    },

    async verifyBoxes(unique, boxes) {
      return new Promise((resolve, reject) => {
        let boxErrors = [];
        let boxesFarm = [];

        for (let index = 0; index < Object.keys(unique).length; index++) {
          const element = Object.keys(unique)[index];
          let found = false;

          for (var i = 0; i < Object.values(boxes).length; i++) {
            if (
              !boxesFarm.includes(Object.values(boxes)[i].code.toUpperCase())
            ) {
              boxesFarm.push(Object.values(boxes)[i].code.toUpperCase());
            }

            if (
              Object.values(boxes)[i].code.toUpperCase() ==
              element.toUpperCase()
            ) {
              found = true;
              break;
            }
          }

          if (!found) {
            boxErrors.push(element.toUpperCase());
          }
        }

        this.boxes_names = boxErrors.length == 0 ? null : boxErrors.join(', ');
        sessionStorage.setItem('boxErrors', JSON.stringify(boxErrors));
        sessionStorage.setItem('boxes', JSON.stringify(boxesFarm));
        resolve();
      });
    },

    drawBadRows() {
      let tbl = document.getElementsByClassName('htCore');
      setTimeout(() => {
        let trs = tbl[0]
          .getElementsByTagName('tbody')[0]
          .getElementsByTagName('tr');
        trs.forEach((item) => {
          let box = item.getElementsByTagName('td')[1];
          if (
            box.innerText != 'Caja' &&
            (box.innerText == '' ||
              Object.values(
                JSON.parse(sessionStorage.getItem('boxErrors'))
              ).includes(box.innerText.toUpperCase()))
          ) {
            box.className = 'alert alert-danger';
          } else {
            box.className = '';
          }
        });
      }, 10);
    },

    validate() {
      if (this.farm_id == null) {
        return this.validationInputsRequired('farm');
      } else if (this.file_sel == null) {
        return this.validationInputsRequired('file');
      } else {
        if (this.isCreate()) {
          this.showHideLoading(true);
          let data = {
            route: 'scales/boxes/savefilecontent',
            farm_id: this.farm_id,
            filename: this.file_sel,
            data_file: this.hotSettings.data,
            count_boxes: this.content_file.count_boxes,
            date_file: this.content_file.date_file,
            total: this.content_file.total,
            scale_version: this.content_file.scale_version,
          };

          Axios.postMasters(data)
            .then((response) => {
              this.showHideLoading();
              this.file_sel = null;
              this.renderer = false;
              this.hotSettings.data = [];
              this.content_file = null;
              this.boxes_names = null;
              this.filesList = [];
              SweetAlert.success(response.data.message).then(() => {
                this.loadFiles();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              SweetAlert.warning(error.response.data.message);
            });
        } else {
          this.showMessageAccess();
          this.message = null;

          this.showHideLoading();
        }
      }
    },

    validateFile() {
      this.message = null;
      this.showHideLoading(true);
      this.renderer = false;
      this.$nextTick(function () {
        this.renderer = true;

        setTimeout(() => {
          let boxErrors = [];
          let boxesActually = {};

          [
            ...document
              .getElementsByClassName('htCore')[0]
              .getElementsByTagName('tbody')[0]
              .getElementsByTagName('tr'),
          ].forEach((item) => {
            let box = item.getElementsByTagName('td')[1];

            if (
              box.innerText != 'Caja' &&
              (box.innerText == '' ||
                !Object.values(
                  JSON.parse(sessionStorage.getItem('boxes'))
                ).includes(box.innerText.toUpperCase()))
            ) {
              box.className = 'alert alert-danger';
            } else {
              box.className = '';
            }
          });

          Object.values(this.hotSettings.data).forEach((item, key) => {
            if (
              item[1] != 'Caja' &&
              (item[1] == '' ||
                !Object.values(
                  JSON.parse(sessionStorage.getItem('boxes'))
                ).includes(item[1].toUpperCase()))
            ) {
              if (!boxErrors.includes(item[1])) {
                boxErrors.push(item[1]);
              }
            }

            if (item[1] != '') {
              for (
                let index = 0;
                index < Object.values(this.content_file.boxes).length;
                index++
              ) {
                const element = Object.values(this.content_file.boxes)[index];
                if (element.code.toUpperCase() == item[1].toUpperCase()) {
                  item[1] = item[1].toUpperCase();
                  item[2] = element.name;
                  this.$set(this.hotSettings.data, key, item);
                  break;
                }
              }
            }

            if (item[1] != 'Caja') {
              if (boxesActually[item[1]] !== undefined) {
                boxesActually[item[1].toUpperCase()] =
                  boxesActually[item[1].toUpperCase()] + 1;
              } else {
                if (boxesActually[item[1]] === undefined) {
                  boxesActually[item[1].toUpperCase()] = 1;
                }
              }
            }
          });

          this.content_file.count_boxes = boxesActually;
          this.content_file.total = Object.keys(this.hotSettings.data).length;
          this.boxes_names =
            boxErrors.length == 0 ? null : boxErrors.join(', ');
          sessionStorage.setItem('boxErrors', JSON.stringify(boxErrors));
          this.showHideLoading();
        }, 10);
      });
    },

    syncScalesBoxes() {
      this.showHideLoading(true);
      Axios.getMasters('scales/boxes/syncScalesBoxes')
        .then((response) => {
          this.showHideLoading();
          SweetAlert.success(response.data.message);
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);

      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('scales/boxes/downloadScales')
        .then((response) => {
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('scales');
  },

  destroyed() {
    this.deselectedItemOnMenu('scales');
    sessionStorage.removeItem('boxErrors');
    sessionStorage.removeItem('boxes');
  },
};
</script>
<style></style>
